module.exports = __webpack_public_path__ + "img/2.563d2046.png";